import { Button as B } from "@rmwc/button";
import styled from "styled-components";
import "@rmwc/button/styles";

export const Button = styled(B)`
  text-transform: none;
`;

export default Button;
